<template>
  <div>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <v-card tile>
        <v-card-title class="justify-space-between pb-4">
          <v-btn icon disabled><v-icon>mdi-clear</v-icon></v-btn>
          <span style="font-size: 20px; color: #00a99d; font-weight: bold"
            >จ่ายยา
          </span>
          <v-btn icon @click="close()" small>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex flex-column">
              <span class="mb-2 font-18 black--text">ค้นหา</span>
              <v-autocomplete
                class="custom-autocomplete"
                v-model="patient"
                outlined
                small
                hide-details="auto"
                dense
                :items="itemSearchPatient"
                return-object
                :item-text="formattedItemText"
                item-value="_id"
                placeholder="กรุณากรอกชื่อ/รหัสพนักงาน"
                clearable
                color="#00a99d"
                @click="searchPatient"
                @keyup="searchPatient"
              >
                <template slot="no-data">
                  <span class="pl-2">ไม่มีข้อมูลผู้ป่วย</span>
                </template>
              </v-autocomplete>
              <!-- <pre>{{ patient }}</pre> -->
            </v-col>

            <v-col v-if="showData">
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <span
                          class="pr-2"
                          style="
                            font-size: 14px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                        >
                          ข้อมูลพนักงาน
                        </span>
                        <v-divider
                          class="mt-1"
                          style="background-color: #ceefed"
                        ></v-divider>
                      </div>
                    </v-col>
                    <v-col>
                      <v-row class="pa-0 mx-0 bg-D5EEED">
                        <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                          <span class="custom-text">รหัสพนักงาน : </span>
                          <span class="custom-text ml-2">
                            {{
                              patient.employee_id ? patient.employee_id : "-"
                            }}
                          </span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                          <span class="custom-text">แผนก : </span>
                          <span class="custom-text ml-2">
                            {{ patient.department ? patient.department : "-" }}
                          </span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                          <span class="custom-text">ชื่อ-สกุล : </span>
                          <span class="custom-text ml-2">{{
                            patient.fullname || ""
                          }}</span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                          <span class="custom-text">หมายเลขโทรศัพท์ : </span>
                          <span class="custom-text ml-2">{{
                            patient.mobile
                          }}</span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                          <span class="custom-text">เพศ : </span>
                          <span class="custom-text ml-2">{{
                            genderPerson(patient.account_title_th)
                          }}</span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                          <span class="custom-text">วัน/เดือน/ปีเกิด : </span>
                          <span class="custom-text ml-2">{{
                            formatDate(patient.birth_date)
                          }}</span>
                        </v-col>
                        <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                          <span class="custom-text">อายุ : </span>
                          <span class="custom-text ml-2">{{
                            ageCalcilar(patient.birth_date)
                          }}</span
                          ><span class="custom-text ml-2">ปี</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" class="d-flex flex-column">
                  <v-row class="pa-0 ma-0">
                    <v-col cols="12" class="pa-0">
                      <div class="d-flex align-center">
                        <span
                          class="pr-2"
                          style="
                            font-size: 14px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                        >
                          ข้อมูลรายการยา
                        </span>
                        <v-divider
                          class="mt-1"
                          style="background-color: #ceefed"
                        ></v-divider>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(drug, index) in itemDrug"
                    :key="index"
                    class=""
                  >
                    <v-col cols="6" sm="5" md="5" lg="5" xl="5">
                      <div class="d-flex flex-column">
                        <span style="font-size: 16px">
                          #{{ index + 1 }} รายการยา
                        </span>
                        <v-autocomplete
                          v-model="drug.list_drug"
                          solo
                          hide-details="auto"
                          dense
                          :items="itemSearchDrug"
                          @keyup="searchDrugList"
                          @input="(e) => setDrug(e, index, 'list')"
                          return-object
                          item-text="name_drug"
                          item-value="_id"
                          placeholder="กรอกรายการยา"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                ไม่พบข้อมูล
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" xl="2" align="center">
                      <div class="d-flex flex-column">
                        <span style="font-size: 16px"> จำนวน</span>
                        <v-text-field
                          type="number"
                          solo
                          hide-details="auto"
                          dense
                          @input="(e) => setDrug(e, index, 'count')"
                          v-model="itemDrug[index].count"
                          placeholder="กรอกจำนวน"
                          :min="0"
                          :max="CheckQuantity(itemDrug[index])"
                          oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                          :rules="[
                            (v) =>
                              (v >= 0 && v <= CheckQuantity(itemDrug[index])) ||
                              'ยาไม่พอ',
                          ]"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="2" md="2" lg="2" xl="2" align="center">
                      <div class="d-flex flex-column">
                        <span style="font-size: 16px">ราคา</span>
                        <v-text-field
                          solo
                          hide-details="auto"
                          dense
                          v-model="itemDrug[index].sum"
                          readonly
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="6" sm="3" md="3" lg="3" xl="3" align="center">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <span style="font-size: 16px">ราคารวม</span>
                          <v-spacer></v-spacer>
                          <v-btn icon x-small @click="delDrug(index)">
                            <v-icon color="red">mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-text-field
                          solo
                          hide-details="auto"
                          dense
                          :value="priceTakingMedicine(itemDrug[index])"
                          small
                          readonly
                        ></v-text-field>
                      </div>
                    </v-col>

                    <!-- ข้อมูลการรับยา -->
                    <v-col cols="12" align-self="center">
                      <v-row class="usageAndAdvice" v-show="show">
                        <v-col
                          class="pa-1"
                          cols="12"
                          align-self="center"
                          style="white-space: wrap; text-overflow: ellipsis"
                        >
                          <span class="w-700 font-14 text-313B41">
                            จำนวนยาในคลัง :
                          </span>
                          <span class="w-300 font-14 text-313B41"
                            >{{ itemDrug[index].list_drug.quantity }}
                          </span>
                          <span> {{ itemDrug[index].list_drug.unit }} </span>
                        </v-col>
                      </v-row>
                      <v-col class="pa-1" cols="1" align-self="center"></v-col>
                      <v-row class="usageAndAdvice" v-show="show">
                        <v-col
                          class="pa-1"
                          cols="12"
                          align-self="center"
                          style="white-space: wrap; text-overflow: ellipsis"
                        >
                          <span class="w-700 font-14 text-313B41">
                            ข้อมูลการใช้ยา :
                          </span>
                          <span class="w-300 font-14 text-313B41"
                            >{{
                              itemDrug[index].list_drug.usage
                                ? itemDrug[index].list_drug.usage
                                : "-"
                            }}
                          </span>
                        </v-col>
                        <v-col
                          class="pa-1"
                          cols="12"
                          align-self="center"
                          style="text-align: center"
                        >
                          <span class="w-700 font-12 text-EB5757">
                            ***
                            {{
                              itemDrug[index].list_drug.advice
                                ? itemDrug[index].list_drug.advice
                                : "ไม่มี"
                            }}
                            ***
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="12" class="text-right py-0">
                      <v-btn icon @click="addDrug">
                        <v-icon color="#00a99d">mdi-plus-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="" cols="7">
                      <span class="w-300 font-18 text-313B41"
                        >สรุปรายการยา {{ quantity(itemDrug) }} รายการ</span
                      >
                    </v-col>
                    <v-col class="" cols="5" align="end">
                      <span class="w-300 font-18 text-313B41">ราคารวม </span>
                      <span class="w-300 font-18 text-3D85E1">
                        {{ netprice(itemDrug) }}
                      </span>
                      <span class="w-300 font-18 text-313B41"> บาท</span>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row align="center" justify="center"
                    ><v-col cols="5" sm="4" md="3"
                      ><v-btn
                        class="rounded-lg"
                        block
                        color="#00a99d"
                        outlined
                        @click="close"
                        >ยกเลิก</v-btn
                      ></v-col
                    ><v-col cols="5" sm="4" md="3"
                      ><v-btn
                        class="rounded-lg"
                        block
                        dark
                        depressed
                        color="#00a99d"
                        :loading="btn_loading"
                        @click="save(patient)"
                        >จ่ายยา</v-btn
                      ></v-col
                    ></v-row
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import functioncryto from "@/services/encrypt.js";
export default {
  data() {
    return {
      dialog: false,
      search: "",
      showData: false,
      btn_loading: false,
      itemDrug: [
        { list_drug: {}, price: "", count: "", sum: "" },
        { list_drug: {}, price: "", count: "", sum: "" },
      ],
      itemSearchDrug: [],
      show: false,
      itemSearchPatient: [],
      patient: [],
    };
  },
  async mounted() {
    this.searchDrugList();
    this.searchPatient();
  },
  watch: {
    patient(val) {
      if (val) {
        this.showData = true;
      } else {
        this.showData = false;
      }
    },
  },
  computed: {
    formattedItemText() {
      return (item) => {
        if (item.employee_id) {
          return `${item.fullname} ( ${item.employee_id} )`;
        } else {
          return item.fullname;
        }
      };
    },
  },
  methods: {
    open() {
      this.dialog = true;
      this.showData = false;
      this.searchDrugList();
      this.searchPatient();
    },
    close() {
      this.dialog = false;
      this.show = false;
      this.search = "";
      this.itemDrug = [
        { list_drug: {}, price: "", count: "", sum: "" },
        { list_drug: {}, price: "", count: "", sum: "" },
      ];
      this.itemSearchDrug = [];
      this.itemSearchPatient = [];
      this.patient = [];
    },
    displayItem(item, type) {
      const { account_title_th, birth_date, mobile } = item;
      switch (type) {
        case "gender":
          if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
          if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
            return "หญิง";
          break;
        case "age":
          if (birth_date) {
            const y = Math.floor(
              moment.duration(moment().diff(birth_date)).asYears()
            );
            return y;
          }
          break;
        case "mobile":
          if (mobile) {
            return mobile;
          }
          break;
      }
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    formatDate(data) {
      if (!data) {
        return null;
      }

      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    displayBirthDate(date) {
      if (!date) return "-";
      return moment(date).locale("th").add(543, "years").format("DD MMMM YYYY");
    },
    CheckQuantity(item) {
      if (item && item.list_drug.quantity) {
        return item.list_drug.quantity;
      } else {
        return 0;
      }
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "";
      }
    },
    ageCalcilar(birth) {
      const today = new Date();
      const birthDate = new Date(birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    async searchDrugList(text) {
      try {
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/druglists/search?biz_id=${sessionStorage.biz_id}&search=${word}`
          )
          .then((res) => {
            this.itemSearchDrug = res.data.data[0].data;
            // console.log("itemSearchDrug", this.itemSearchDrug);
          });
      } catch (error) {
        console.error();
      }
    },
    async searchPatient(search) {
      try {
        let word = "";
        if (search !== undefined) {
          if (search.target.value.length !== 0) {
            word = search.target.value;
          }
        }
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("search", word || "");
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search_record?${params}`
          )
          .then((res) => {
            if (res.data) {
              let patientList = res.data.data[0].data;
              // patientList = patientList.filter((user) => user.one_id !== null);
              patientList.forEach((element) => {
                element.fullname = `${
                  element.account_title_th ? element.account_title_th : ""
                }${element.first_name_th ? element.first_name_th : ""} ${
                  element.last_name_th ? element.last_name_th : ""
                }`;
              });
              this.itemSearchPatient = Object.assign([], patientList);
              // console.log("itemSearchPatient", this.itemSearchPatient);
            }
          });
      } catch (error) {
        console.error();
      }
    },
    priceTakingMedicine(item) {
      let price = 0;
      if (item.count !== "") {
        price = item.count * item.price;
      }
      return price.toFixed(2);
    },
    setDrug(event, index, type) {
      switch (type) {
        case "count":
          this.itemDrug[index].sum = parseFloat(
            parseFloat(this.itemDrug[index].price) * parseInt(event)
          );
          break;
        case "list":
          this.itemDrug[index].list_drug = event;
          this.itemDrug[index].count = 1;
          this.itemDrug[index].price = event.price;
          this.itemDrug[index].sum = event.price;
          this.show = true;
          break;
        case "price":
          this.itemDrug[index].price = event.price;
          break;
        default:
          break;
      }
    },
    addDrug() {
      this.itemDrug.push({ list_drug: {}, price: "", count: "", sum: "" });
    },
    delDrug(index) {
      if (index > -1) {
        // only splice array when item is found
        this.itemDrug.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    quantity(itemDrug) {
      let quantity = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          quantity++;
        }
      });
      return quantity;
    },
    netprice(itemDrug) {
      let netprice = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          netprice += Number(ele.count) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },
    async save() {
      let drug_list = [];

      //   console.log(
      //     "🚀 ~ file: Conference.vue:114 ~ save ~ $refs:",

      //     itemDrug,
      //     patient_name
      //   );
      this.itemDrug.forEach((element) => {
        if (element.price != "" || element.price == "0") {
          drug_list.push({
            ...element.list_drug,
            total: element.sum,
            count: element.count,
            status: true
          });
        }
      });
      const payload = {
        biz_id: this.patient.biz_id,
        patient_id: this.patient.one_id,
        patient_cid : this.patient.cid,
        // patient_cid: JSON.parse(JSON.stringify(functioncryto.decrypt(c))),
        patient_name: this.patient.fullname,
        nurse_name: sessionStorage.accountName,
        nurse_id: sessionStorage.oneId,
        drug_list,
        status: "confirm"
      };
      if (payload.drug_list[0] !== undefined) {
        const { data: { result } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/prescription`,
          payload
        );
        if (result == "success") {
          this.$swal.fire({
            icon: "success",
            title: "บันทึกการจ่ายยาสำเร็จ",
            showConfirmButton: false,
            timer: 1000,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่สำเร็จ",
            text: "กรุณาลองใหม่อีกครั้ง",
            timer: 3000,
            showConfirmButton: false,
            showCloseButton: false,
          });
        }
        this.$emit("success");
        this.close();
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ไม่สำเร็จ",
          text: "กรุณากรอกรายการยาอีกครั้ง",
          timer: 3000,
          showConfirmButton: false,
          showCloseButton: false,
        });
      }
      console.log("payload", payload);
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.usageAndAdvice {
  border: 1px solid #00000061;
  border-radius: 4px;
  margin: 0px;
}
.custom-autocomplete {
  border-radius: 6px;
}
.custom-text {
  font-size: 16px;
  color: black;
}
</style>
